import {useTranslation} from "../../__snowpack__/link/packages/old-i18n/dist/i18n.esm.js";
import {useMemo, useCallback} from "react";
export function useAdminPermissionsItems(adminPermissions) {
  const {
    t
  } = useTranslation();
  return useMemo(() => [{
    title: t("whiteLabel.content.adminPermissionsSection.workOrder.title"),
    contents: [{
      text: t("whiteLabel.content.adminPermissionsSection.workOrder.view"),
      checked: adminPermissions?.permission_view_work_orders,
      name: "admin_permissions.permission_view_work_orders"
    }]
  }, {
    title: t("whiteLabel.content.adminPermissionsSection.template.title"),
    contents: [{
      text: t("whiteLabel.content.adminPermissionsSection.template.view"),
      checked: adminPermissions?.permission_view_templates,
      name: "admin_permissions.permission_view_templates"
    }]
  }, {
    title: t("whiteLabel.content.adminPermissionsSection.reports.title"),
    contents: [{
      text: t("whiteLabel.content.adminPermissionsSection.reports.view"),
      checked: adminPermissions?.permission_view_reports,
      name: "admin_permissions.permission_view_reports"
    }]
  }, {
    title: t("whiteLabel.content.adminPermissionsSection.dynamicForm.title"),
    contents: [{
      text: t("whiteLabel.content.adminPermissionsSection.dynamicForm.view"),
      checked: adminPermissions?.permission_view_dynamic_forms,
      name: "admin_permissions.permission_view_dynamic_forms"
    }]
  }, {
    title: t("whiteLabel.content.adminPermissionsSection.demand.title"),
    contents: [{
      text: t("whiteLabel.content.adminPermissionsSection.demand.view"),
      checked: adminPermissions?.permission_view_on_demand_instructions,
      name: "admin_permissions.permission_view_on_demand_instructions"
    }]
  }, {
    title: t("whiteLabel.content.adminPermissionsSection.utilities.title"),
    contents: [{
      text: t("whiteLabel.content.adminPermissionsSection.utilities.view"),
      checked: adminPermissions?.permission_view_utilities,
      name: "admin_permissions.permission_view_utilities"
    }]
  }], [adminPermissions?.permission_view_dynamic_forms, adminPermissions?.permission_view_on_demand_instructions, adminPermissions?.permission_view_reports, adminPermissions?.permission_view_templates, adminPermissions?.permission_view_utilities, adminPermissions?.permission_view_work_orders, t]);
}
export function useAccountPermissionsItems(accountPermissions, {
  translateBase = "whiteLabel.content.defaultAccountPermissions",
  namePrefix = "permissions"
} = {}) {
  const {
    t
  } = useTranslation();
  const _dependenceParentPermission = useCallback((permissionArray, parentPermission) => {
    const parent = permissionArray.find((item) => {
      return item.name == parentPermission;
    });
    return parent?.checked;
  }, []);
  return useMemo(() => [{
    title: t(`${translateBase}.dashboard.title`),
    contents: [{
      text: t(`${translateBase}.dashboard.view`),
      checked: accountPermissions?.permission_view_dashboard,
      name: `${namePrefix}.permission_view_dashboard`
    }]
  }, {
    title: t(`${translateBase}.property.title`),
    contents: [{
      text: t(`${translateBase}.property.view`),
      checked: accountPermissions?.permission_view_property_groups,
      name: `${namePrefix}.permission_view_property_groups`
    }]
  }, {
    title: t(`${translateBase}.unit.title`),
    contents: [{
      text: t(`${translateBase}.unit.view`),
      checked: accountPermissions?.permission_view_units,
      name: `${namePrefix}.permission_view_units`
    }]
  }, {
    title: t(`${translateBase}.document.title`),
    contents: [{
      text: t(`${translateBase}.document.manager`),
      checked: accountPermissions?.permission_view_documents,
      name: `${namePrefix}.permission_view_documents`
    }, {
      text: t(`${translateBase}.document.setup`),
      checked: accountPermissions?.permission_view_documents_setup,
      name: `${namePrefix}.permission_view_documents_setup`
    }]
  }, {
    title: t(`${translateBase}.template.title`),
    contents: [{
      text: t(`${translateBase}.template.view`),
      checked: accountPermissions?.permission_view_templates,
      name: `${namePrefix}.permission_view_templates`
    }, {
      text: t(`${translateBase}.template.calendar`),
      checked: accountPermissions?.permission_view_templates_calendar,
      name: `${namePrefix}.permission_view_templates_calendar`
    }, {
      text: t(`${translateBase}.template.trigger`),
      checked: accountPermissions?.permission_view_trigger_templates,
      name: `${namePrefix}.permission_view_trigger_templates`
    }, {
      text: t(`${translateBase}.template.code`),
      help: t(`${translateBase}.template.codeHelp`),
      checked: accountPermissions?.permission_view_code_templates_tasks,
      name: `${namePrefix}.permission_view_code_templates_tasks`
    }]
  }, {
    title: t(`${translateBase}.workflow.title`),
    contents: [{
      text: t(`${translateBase}.workflow.view`),
      checked: accountPermissions?.permission_view_workflows,
      name: `${namePrefix}.permission_view_workflows`
    }]
  }, {
    title: t(`${translateBase}.unitWorkflow.title`),
    contents: [{
      text: t(`${translateBase}.unitWorkflow.view`),
      checked: accountPermissions?.permission_view_unit_workflows,
      name: `${namePrefix}.permission_view_unit_workflows`
    }, {
      text: t(`${translateBase}.unitWorkflow.make`),
      checked: accountPermissions?.permission_view_make_ready_board,
      name: `${namePrefix}.permission_view_make_ready_board`
    }, {
      text: t(`${translateBase}.unitWorkflow.residentInspection`),
      checked: accountPermissions?.permission_resident_inspection,
      name: `${namePrefix}.permission_resident_inspection`
    }]
  }, {
    title: t(`${translateBase}.dynamicForm.title`),
    contents: [{
      text: t(`${translateBase}.dynamicForm.view`),
      checked: accountPermissions?.permission_view_dynamic_forms,
      name: `${namePrefix}.permission_view_dynamic_forms`
    }]
  }, {
    title: t(`${translateBase}.demand.title`),
    contents: [{
      text: t(`${translateBase}.demand.view`),
      checked: accountPermissions?.permission_view_on_demand_instructions,
      name: `${namePrefix}.permission_view_on_demand_instructions`
    }]
  }, {
    title: t(`${translateBase}.report.title`),
    contents: [{
      text: t(`${translateBase}.report.view`),
      checked: accountPermissions?.permission_view_reports,
      name: `${namePrefix}.permission_view_reports`
    }, {
      text: t(`${translateBase}.report.mimo`),
      checked: accountPermissions?.permission_view_reports_mimo,
      name: `${namePrefix}.permission_view_reports_mimo`
    }]
  }, {
    title: t(`${translateBase}.contact.title`),
    contents: [{
      text: t(`${translateBase}.contact.view`),
      checked: accountPermissions?.permission_view_contacts,
      name: `${namePrefix}.permission_view_contacts`
    }]
  }, {
    title: t(`${translateBase}.workOrder.title`),
    contents: [{
      text: t(`${translateBase}.workOrder.view`),
      checked: accountPermissions?.permission_view_work_order,
      name: `${namePrefix}.permission_view_work_order`
    }]
  }, {
    title: t(`${translateBase}.sftp.title`),
    contents: [{
      text: t(`${translateBase}.sftp.upload`),
      checked: accountPermissions?.permission_upload_sftp,
      name: `${namePrefix}.permission_upload_sftp`
    }]
  }, {
    title: t(`${translateBase}.messenger.title`),
    contents: [{
      text: t(`${translateBase}.messenger.live`),
      checked: accountPermissions?.permission_live_chat,
      name: `${namePrefix}.permission_live_chat`
    }]
  }, {
    title: t(`${translateBase}.other.title`),
    contents: [{
      text: t(`${translateBase}.other.photo`),
      checked: accountPermissions?.permission_mobile_photo_annotation,
      name: `${namePrefix}.permission_mobile_photo_annotation`
    }]
  }, {
    title: t(`${translateBase}.approvalStep.title`),
    contents: [{
      text: t(`${translateBase}.approvalStep.define`),
      checked: accountPermissions?.permission_define_approval_steps,
      name: `${namePrefix}.permission_define_approval_steps`
    }]
  }, {
    title: t(`${translateBase}.sso.title`),
    contents: [{
      text: t(`${translateBase}.sso.login`),
      checked: accountPermissions?.permission_login_with_sso,
      name: `${namePrefix}.permission_login_with_sso`
    }, {
      text: t(`${translateBase}.sso.properties`),
      checked: accountPermissions?.permission_sso_get_properties_from_idp,
      name: `${namePrefix}.permission_sso_get_properties_from_idp`,
      conditionShow: (contents) => _dependenceParentPermission(contents, `${namePrefix}.permission_login_with_sso`)
    }, {
      text: t(`${translateBase}.sso.roles`),
      checked: accountPermissions?.permission_sso_get_role_from_idp,
      name: `${namePrefix}.permission_sso_get_role_from_idp`,
      conditionShow: (contents) => _dependenceParentPermission(contents, `${namePrefix}.permission_login_with_sso`)
    }]
  }], [accountPermissions?.permission_define_approval_steps, accountPermissions?.permission_mobile_photo_annotation, accountPermissions?.permission_login_with_sso, accountPermissions?.permission_sso_get_properties_from_idp, accountPermissions?.permission_sso_get_role_from_idp, accountPermissions?.permission_live_chat, accountPermissions?.permission_upload_sftp, accountPermissions?.permission_view_code_templates_tasks, accountPermissions?.permission_view_contacts, accountPermissions?.permission_view_dashboard, accountPermissions?.permission_view_documents, accountPermissions?.permission_view_documents_setup, accountPermissions?.permission_view_dynamic_forms, accountPermissions?.permission_view_on_demand_instructions, accountPermissions?.permission_view_property_groups, accountPermissions?.permission_view_reports, accountPermissions?.permission_view_reports_mimo, accountPermissions?.permission_view_templates, accountPermissions?.permission_view_templates_calendar, accountPermissions?.permission_view_trigger_templates, accountPermissions?.permission_view_unit_workflows, accountPermissions?.permission_view_make_ready_board, accountPermissions?.permission_resident_inspection, accountPermissions?.permission_view_units, accountPermissions?.permission_view_work_order, accountPermissions?.permission_view_workflows, namePrefix, t, translateBase, _dependenceParentPermission]);
}
